
import {Toast} from 'vant'
import { loginWxAuthorizeSendCode, loginPhoneSendCode, loginWxAuthorizeVerifyCode, loginPhoneVerifyCode } from '@/api/shareH5.js'
import { RegPhone } from '@/utils/validate.js'
import callApp from '@/config/callApp.js'

export default {
    data() {
        return {
            phone:'',
            time:60,
            code:'',
            hadWechat: false, // 手机号已绑定其他微信
        }
    },
    methods: {
        loginForPhone(params) {
            loginPhoneVerifyCode(params).then(r => {
                // 浏览器应用宝
                window.location.href = callApp.yingyongbao;
            }).catch(_ => {})
        },
        loginForWx(params) {
            loginWxAuthorizeVerifyCode(params).then(r => {
                // 浏览器应用宝
                window.location.href = callApp.yingyongbao;
            }).catch(_ => {})
        },
        sendMsg(){
            if(this.time != 60){
                return;
            }
            if(!RegPhone.test(this.phone)){
                Toast('请输入正确的手机号！');
                return;
            }
            if (this.hadWechat) {
                // 已绑定其他微信，使用手机验证码登陆
                this.getPhoneCode();
                return;
            }
            loginWxAuthorizeSendCode({phone: this.phone}).then(r => {
                //请求成功后的then方法
                this.hadWechat = false; 
                let DJS = setInterval(_=>{
                    if(this.time <=0){
                        clearInterval(DJS);
                        this.time = 60;
                        return
                    }
                    this.time -- ;
                },1000)
            }).catch(_ => {
                
                this.getPhoneCode();
            })
        },
        getPhoneCode() {
            this.hadWechat = true;
            loginPhoneSendCode({phone: this.phone}).then(r => {
                //请求成功后的then方法
                let DJS = setInterval(_=>{
                    if(this.time <=0){
                        clearInterval(DJS);
                        this.time = 60;
                        return
                    }
                    this.time -- ;
                },1000)
            }).catch(_ => {})
        },
        clearEmpty() {
            window.scroll(0, 0)
        }
    },
    components: { Toast }
}
